import { render, staticRenderFns } from "./larvalapprates.vue?vue&type=template&id=403885b8&"
import script from "./larvalapprates.vue?vue&type=script&lang=js&"
export * from "./larvalapprates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports